import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./style.css"
import { FiLogOut } from 'react-icons/fi'
import { callSocket } from '../../utils/socket';
import { clearLocalStorage } from '../../utils/localstorage';
import { IoIosArrowBack } from "react-icons/io";

const Logout = ({ showLogo, showLogout = true, close = null, backAction = null }) => {
    const navigate = useNavigate()
    const dev = localStorage.getItem("indi-device-type")
    const platform = localStorage.getItem("indi-platform")
    const isUsingApp = platform && (platform === "ios-app" || platform === "android-app");

    const logout = () => {
        if (!isUsingApp) {
            navigate("/login");
            // window.location.href = "/login";
        } else {
            callSocket(`logout-mobile`);
        }

        clearLocalStorage();
    }

    return (
        <div id="logout-wrapper">
            {backAction && <IoIosArrowBack className="header-back-button" onClick={() => {
                backAction()
            }} />}
            <div className='logout-indi-logo'>
                {showLogo && <img src='/assets/images/logo.png' />}
            </div>
            {
                showLogout &&
                <div className='logout-icons' onClick={() => logout()}>
                    <FiLogOut />
                    <div className='logout-text'>
                        <p >Log out</p>
                    </div>
                </div>
            }
        </div>
    );
};

export default Logout;